export default {
  get: function() {
    return {
      values: [],
      access: null,
      fetching: false,
      minting: false,
      error: false,
      success: false,
    };
  },
};
